var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.06266 9.49984C2.06266 9.35734 2.11516 9.21484 2.22766 9.10234L6.78016 4.54984C6.99766 4.33234 7.35766 4.33234 7.57516 4.54984C7.79266 4.76734 7.79266 5.12734 7.57516 5.34484L3.42016 9.49984L7.57516 13.6548C7.79266 13.8723 7.79266 14.2323 7.57516 14.4498C7.35766 14.6673 6.99766 14.6673 6.78016 14.4498L2.22766 9.89734C2.11516 9.78484 2.06266 9.64234 2.06266 9.49984Z",
    fill: "#7B2928"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19 9.5C2.19 9.1925 2.445 8.9375 2.7525 8.9375L15.375 8.9375C15.6825 8.9375 15.9375 9.1925 15.9375 9.5C15.9375 9.8075 15.6825 10.0625 15.375 10.0625L2.7525 10.0625C2.445 10.0625 2.19 9.8075 2.19 9.5Z",
    fill: "#7B2928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.fc2d9f14fabfb88ada05109a4c6ef60c.svg";
export { ForwardRef as ReactComponent };